import { useDispatch } from 'react-redux'
import { closeModal, openModal as rawOpenModal } from '../../Flux/Slice/ModalSlice/ModalSlice.js'
import type { ModalPropsMap, ModalResultMap, ModalTypeName } from './ModalMap.js'
import { useModalListener } from './ModulListenerContext.js'

/**
 * This hook wires together all the modal logic to provide an entrypoint for actually opening modals.
 * It interplays with the modal listener context to provide a way to pass results back to the caller.
 * Note that this here is the type-wise "breaking" point, in that some casting takes place here to effectively
 * coerce result and param types correctly.
 * Although due to the use of the generic type, this is quite tame.
 */
export const useModal = () => {
  const dispatch = useDispatch()
  const { setListener, callListener, clearListener } = useModalListener()

  return {
    openModal: <T extends ModalTypeName>(modalType: T, props: ModalPropsMap[T], onComplete?: (result: ModalResultMap[T]) => void) => {
      setListener(onComplete as (r: unknown) => void)
      dispatch(rawOpenModal({ modalType, props }))
    },
    closeModal: (result?: unknown) => {
      dispatch(closeModal())

      if (result !== undefined) {
        callListener(result)
      } else {
        clearListener()
      }
    }
  }
}
